module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isMobile),
      expression: "!isMobile"
    }]
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "guide right"
  }, [_c('div', {
    staticClass: "msg"
  }, [_c('div', {
    staticClass: "control-section"
  }, [_c('div', {
    staticClass: "arrow-cluster"
  }, [_c('div', {
    staticClass: "arrow-row top"
  }, [_c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("↑")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("旋")])])]), _vm._v(" "), _c('div', {
    staticClass: "arrow-row bottom"
  }, [_c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("←")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("左")])]), _vm._v(" "), _c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("↓")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("下")])]), _vm._v(" "), _c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("→")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("右")])])])]), _vm._v(" "), _c('div', {
    staticClass: "action-cluster"
  }, [_c('div', {
    staticClass: "key-wrapper space-wrapper"
  }, [_c('div', {
    staticClass: "key-cap space"
  }, [_vm._v("Space")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("落")])])]), _vm._v(" "), _c('div', {
    staticClass: "func-cluster"
  }, [_c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("音")])]), _vm._v(" "), _c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("P")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("止")])]), _vm._v(" "), _c('div', {
    staticClass: "key-wrapper"
  }, [_c('div', {
    staticClass: "key-cap"
  }, [_vm._v("R")]), _vm._v(" "), _c('span', {
    staticClass: "key-label"
  }, [_vm._v("复")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63d44803"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/guide/index.vue
// module id = 175
// module chunks = 1